import React,{useState,useEffect,useRef} from "react";
import { Trans, useTranslation} from 'react-i18next'
import './ReleaseMusic.css'
import UploadCoverArt from './../../../../images/uploadcoverart.png'
import Select from 'react-select'
import Cookies from "universal-cookie";
import DisclaimerPopup from './../../../../images/settingsdisclaimericon.png'
import ArrowDown from './../../../../images/arrowdown.png'
import { useSwitch } from '@mui/base/useSwitch';
import clsx from 'clsx';
import { styled } from '@mui/system';
import { useJwt, decodeToken } from "react-jwt";
import {useLocation,useNavigate} from "react-router-dom";
import {Switch} from "@nextui-org/switch";
import axios from 'axios' 


function AlbumDetails({pagePath,setPagePath,getMonthNo,getDateNo,switchChecked,setSwitchChecked,albumImage,setAlbumImage,releaseTitle,setReleaseTitle,distributeAs,setDistribute,format,setFormat,totalVolumes,setTotalVolumes,explicitAlbumContent,setExplicitAlbumContent,consumerReleaseDate,setConsumerReleaseDate,consumerReleaseTime,setConsumerReleaseTime,preorderDate,setPreorderDate,originalReleaseDate,setOriginalReleaseDate,recordingYear,setRecordingYear,recordingLocation,setRecordingLocation,cCopyrightYear,setCCopyrightYear,cCopyrightText,setCCopyrightTexy,pCopyrightYear,setPCopyrightYear,pCopyrightText,setPCopyrightTexy,genre,setGenre,subgenre,setSubGenre,alternategenre,setAlternateGenre,alternateSubgenre,setAlternateSubGenre,albumLanguage,setAlbumLanguage,formatcontainerclass,setFormatContainerClass,defaultdatecontainerclass,setDefaultDateContainerClass,releasedatecontainerclass,setReleaseDateContainerClass,genrecontainerclass,setGenreContainerClass}) { 
    const ref = useRef(null)
    const consumerdateInputRef = useRef(null);
    const preorderdateInputRef = useRef(null);
    const originaldateInputRef = useRef(null);
    const inputRef = useRef(null)
    const [artistName,setArtistname] = useState("")
    const [disclaimer,setDisclaimer] = useState(false)
    const {t, i18n } = useTranslation();
    const [ImageDragActive , setImageDragActive] = useState(false)
    const [albumImageError,setAlbumImageError] = useState(false)
    const [distributeError, setDistibuteError] = useState(false)
    const cookies = new Cookies(null ,{ path: '/' });
    const [formatError,setFormatError]  = useState(false)
    const [genreError,setGenreError] = useState(false)
    const [releaseTitleError,setReleaseTitleError] = useState(false)
    const navigate = useNavigate();
    const [displayGenre,setDisplayGenre] = useState("")
    const [consumerDateObj,setConsumerDateObj] = useState()
    const [originalDateObj,setOriginalDateObj] = useState()
    const [preorderDateObj,setPreorderDateObj] = useState()
    const [dateerror,setDateError] = useState(false)
    const [LangOption,setLangOptions] = useState([])
    var switchstatus = switchChecked
    const location = useLocation();
    const distributeOptions = [{value:'New Release', label:'New Release'},
                               {value:'Remix', label:'Remix'},
                               {value:'Re-Release', label:'Re-Release'},
                               {value:'Compilation', label:'Compilation'}]

    const jpformatOptions = [{ value: 'Single', label:'シングル(１トラックのみ)' },
                               { value: 'EP', label: 'EP (5トラックまで)' },
                               { value: 'Album', label: 'アルバム (無制限)' }]

    const formatOptions = [{ value: 'Single', label:'Single (up to 1 track)' },
                               { value: 'EP', label: 'EP (up to 5 tracks)' },
                               { value: 'Album', label: 'Album (unlimited tracks)' }]

    const ExplicitContentOptions = [{ value: true, label: 'Yes' },
                                  { value: false, label: 'No' }]
        
                              
    const LanguageOptions = [{ value: 'Afar', label: 'Afar' },    { value: 'Abkhazian', label: 'Abkhazian' },    { value: 'Avestan', label: 'Avestan' },    { value: 'Afrikaans', label: 'Afrikaans' },    { value: 'Akan', label: 'Akan' },    { value: 'Amharic', label: 'Amharic' },    { value: 'Aragonese', label: 'Aragonese' },    { value: 'Arabic', label: 'Arabic' },    { value: 'Assamese', label: 'Assamese' },    { value: 'Avaric', label: 'Avaric' },    { value: 'Aymara', label: 'Aymara' },    { value: 'Azerbaijani', label: 'Azerbaijani' },    { value: 'Bashkir', label: 'Bashkir' },    { value: 'Belarusian', label: 'Belarusian' },    { value: 'Bulgarian', label: 'Bulgarian' },    { value: 'Bhojpuri', label: 'Bhojpuri' },    { value: 'Bislama', label: 'Bislama' },    { value: 'Bambara', label: 'Bambara' },    { value: 'Bengali', label: 'Bengali' },    { value: 'Tibetan', label: 'Tibetan' },    { value: 'Breton', label: 'Breton' },    { value: 'Bosnian', label: 'Bosnian' },    { value: 'Catalan', label: 'Catalan' },    { value: 'Chechen', label: 'Chechen' },    { value: 'Chamorro', label: 'Chamorro' },    { value: 'Chechen', label: 'Chechen' },    { value: 'Chinese (Simplified)', label: 'Chinese (Simplified)' },    { value: 'Chinese (Traditional)', label: 'Chinese (Traditional)' },    { value: 'Corsican', label: 'Corsican' },    { value: 'Creole, English based', label: 'Creole, English based' },    { value: 'Creole, French based', label: 'Creole, French based' },    { value: 'Creole, Portuguese based', label: 'Creole, Portuguese based' },    { value: 'Cree', label: 'Cree' },    { value: 'Czech', label: 'Czech' },    { value: 'Church Slavic', label: 'Church Slavic' },    { value: 'Chuvash', label: 'Chuvash' },    { value: 'Welsh', label: 'Welsh' },    { value: 'Danish', label: 'Danish' },    { value: 'German', label: 'German' },    { value: 'Divehi', label: 'Divehi' },    { value: 'Dzongkha', label: 'Dzongkha' },    { value: 'Ewe', label: 'Ewe' },    { value: 'Greek', label: 'Greek' },    { value: 'English', label: 'English' },    { value: 'Esperanto', label: 'Esperanto' },    { value: 'Spanish', label: 'Spanish' },    { value: 'Spanish (Latin America)', label: 'Spanish (Latin America)' },    { value: 'Estonian', label: 'Estonian' },    { value: 'Basque', label: 'Basque' },    { value: 'Persian', label: 'Persian' },    { value: 'Fulah', label: 'Fulah' },    { value: 'Finnish', label: 'Finnish' },    { value: 'Fijian', label: 'Fijian' },
    { value: 'Faroese', label: 'Faroese' },    { value: 'French', label: 'French' },    { value: 'Western Frisian', label: 'Western Frisian' },    { value: 'Irish', label: 'Irish' },    { value: 'Gaelic', label: 'Gaelic' },    { value: 'Galician', label: 'Galician' },    { value: 'Guarani', label: 'Guarani' },    { value: 'Gujarati', label: 'Gujarati' },    { value: 'Manx', label: 'Manx' },    { value: 'Hausa', label: 'Hausa' },    { value: 'Haitian Creole', label: 'Haitian Creole' },    { value: 'Hebrew', label: 'Hebrew' },{ value: 'Hindi', label: 'Hindi' },{ value: 'Hiri Motu', label: 'Hiri Motu' },    { value: 'Croatian', label: 'Croatian' },    { value: 'Haitian', label: 'Haitian' },    { value: 'Hungarian', label: 'Hungarian' },    { value: 'Armenian', label: 'Armenian' },    { value: 'Herero', label: 'Herero' },    { value: 'Interlingua', label: 'Interlingua' },    { value: 'Indonesian', label: 'Indonesian' },    { value: 'Interlingue', label: 'Interlingue' },    { value: 'Igbo', label: 'Igbo' },    { value: 'Sichuan Yi', label: 'Sichuan Yi' },{ value: 'Inupiaq', label: 'Inupiaq' },    { value: 'Ido', label: 'Ido' },    { value: 'Icelandic', label: 'Icelandic' },    { value: 'Italian', label: 'Italian' },    { value: 'Inuktitut', label: 'Inuktitut' },    { value: 'Japanese', label: 'Japanese' },    { value: 'Japanese Katakana', label: 'Japanese Katakana' },    { value: 'Japanese Roman', label: 'Japanese Roman' },{ value: 'Javanese', label: 'Javanese' },{ value: 'Georgian', label: 'Georgian' },{ value: 'Kongo', label: 'Kongo' },{ value: 'Kikuyu', label: 'Kikuyu' },    { value: 'Kuanyama', label: 'Kuanyama' },    { value: 'Kazakh', label: 'Kazakh' },    { value: 'Kalaallisut', label: 'Kalaallisut' },    { value: 'Kannada', label: 'Kannada' },    { value: 'Korean', label: 'Korean' },{ value: 'Kanuri', label: 'Kanuri' },    { value: 'Kashmiri', label: 'Kashmiri' },    { value: 'Kurdish', label: 'Kurdish' },    { value: 'Komi', label: 'Komi' },    { value: 'Cornish', label: 'Cornish' },    { value: 'Kirghiz', label: 'Kirghiz' },    { value: 'Latin', label: 'Latin' },    { value: 'Luxembourgish', label: 'Luxembourgish' },    { value: 'Luganda', label: 'Luganda' },    { value: 'Limburgan', label: 'Limburgan' },    { value: 'Lingala', label: 'Lingala' },{ value: 'Lao', label: 'Lao' },{ value: 'Lithuanian', label: 'Lithuanian' },    { value: 'Luba-Katanga', label: 'Luba-Katanga' },    { value: 'Latvian', label: 'Latvian' },
    { value: 'Malagasy', label: 'Malagasy' },    { value: 'Magahi', label: 'Magahi' },    { value: 'Maithili', label: 'Maithili' },    { value: 'Marshallese', label: 'Marshallese' },{ value: 'Maori', label: 'Maori' },{ value: 'Macedonian', label: 'Macedonian' },    { value: 'Malayalam', label: 'Malayalam' },    { value: 'Mongolian', label: 'Mongolian' },{ value: 'Marathi', label: 'Marathi' },{ value: 'Malay', label: 'Malay' },{ value: 'Maltese', label: 'Maltese' },{ value: 'Burmese', label: 'Burmese' },{ value: 'Nauru', label: 'Nauru' },{ value: 'Norwegian Bokmål', label: 'Norwegian Bokmål' },{ value: 'North Ndebele', label: 'North Ndebele' },{ value: 'Nepali', label: 'Nepali' },{ value: 'Ndonga', label: 'Ndonga' },{ value: 'Dutch', label: 'Dutch' },{ value: 'Norwegian Nynorsk', label: 'Norwegian Nynorsk' },{ value: 'Norwegian', label: 'Norwegian' },{ value: 'South Ndebele', label: 'South Ndebele' },{ value: 'Navajo', label: 'Navajo' },    { value: 'Chichewa', label: 'Chichewa' },{ value: 'Occitan', label: 'Occitan' },{ value: 'Ojibwa', label: 'Ojibwa' },{ value: 'Oromo', label: 'Oromo' },{ value: 'Oriya', label: 'Oriya' },{ value: 'Ossetian', label: 'Ossetian' },{ value: 'Punjabi', label: 'Punjabi' },{ value: 'Pali', label: 'Pali' },{ value: 'Polish', label: 'Polish' },{ value: 'Pushto', label: 'Pushto' },    { value: 'Portuguese', label: 'Portuguese' },   { value: 'Quechua', label: 'Quechua' },    { value: 'Romansh', label: 'Romansh' },    { value: 'Rundi', label: 'Rundi' },    { value: 'Romanian', label: 'Romanian' },{ value: 'Russian', label: 'Russian' },{ value: 'Kinyarwanda', label: 'Kinyarwanda' },    { value: 'Sanskrit', label: 'Sanskrit' },    { value: 'Sardinian', label: 'Sardinian' },    { value: 'Sindhi', label: 'Sindhi' },{ value: 'Northern Sami', label: 'Northern Sami' },{ value: 'Sango', label: 'Sango' },    { value: 'Sinhala', label: 'Sinhala' },    { value: 'Slovak', label: 'Slovak' },    { value: 'Slovene', label: 'Slovene' },    { value: 'Samoan', label: 'Samoan' },    { value: 'Shona', label: 'Shona' },    { value: 'Somali', label: 'Somali' },    { value: 'Serbian', label: 'Serbian' },    { value: 'Swati', label: 'Swati' },    { value: 'Sotho, Southern', label: 'Sotho, Southern' },    { value: 'Sundanese', label: 'Sundanese' },    { value: 'Swedish', label: 'Swedish' },    { value: 'Swahili', label: 'Swahili' },    { value: 'Tamil', label: 'Tamil' },   { value: 'Telugu', label: 'Telugu' },    { value: 'Tajik', label: 'Tajik' },
    { value: 'Thai', label: 'Thai' },    { value: 'Tigrinya', label: 'Tigrinya' },    { value: 'Turkmen', label: 'Turkmen' },    { value: 'Tagalog', label: 'Tagalog' },    { value: 'Tswana', label: 'Tswana' },{ value: 'Tonga (Tonga Islands)', label: 'Tonga (Tonga Islands)' },    { value: 'Turkish', label: 'Turkish' },    { value: 'Tsonga', label: 'Tsonga' },    { value: 'Tatar', label: 'Tatar' },    { value: 'Twi', label: 'Twi' },    { value: 'Tahitian', label: 'Tahitian' },    { value: 'Uighur', label: 'Uighur' },    { value: 'Ukrainian', label: 'Ukrainian' },    { value: 'Urdu', label: 'Urdu' },    { value: 'Uzbek', label: 'Uzbek' },    { value: 'Venda', label: 'Venda' },{ value: 'Vietnamese', label: 'Vietnamese' },    { value: 'Volapük', label: 'Volapük' },    { value: 'Walloon', label: 'Walloon' },    { value: 'Wolof', label: 'Wolof' },    { value: 'Xhosa', label: 'Xhosa' },    { value: 'Yiddish', label: 'Yiddish' },    { value: 'Cantonese', label: 'Cantonese' },{ value: 'Yoruba', label: 'Yoruba' },    { value: 'Zhuang', label: 'Zhuang' },    { value: 'Chinese', label: 'Chinese' },    { value: 'Zulu', label: 'Zulu' }    ]

    const genreOptions = [{ value: 'ALTERNATIVE', label: 'Alternative' },
    { value: 'AUDIOBOOKS', label: 'Audiobooks' },
    { value: 'BLUES', label: 'Blues' },
    { value:'CHILDRENS_MUSIC',  label:'Children’s Music'  },
    { value: 'CLASSICAL', label: 'Classical' },
    { value: 'COMEDY', label: 'Comedy' },
    { value: 'COUNTRY', label: 'Country' },
    { value: 'DANCE', label: 'Dance' },
    { value: 'ELECTRONIC', label: 'Electronic' },
    { value: 'FOLK', label: 'Folk' },
    { value: 'HIP_HOP_RAP', label: 'Hip hop/Rap' },
    { value: 'HOLIDAY', label: 'Holiday' },
    { value: 'INSPIRATIONAL', label: 'Inspirational' },
    { value: 'JAZZ', label: 'Jazz' },
    { value: 'LATIN', label: 'Latin' },
    { value: 'NEW_AGE', label: 'New Age' },
    { value: 'OPERA', label: 'Opera' },
    { value: 'POP', label: 'Pop' },
    { value: 'R_B_SOUL', label: 'R&B/Soul' },
    { value: 'REGGAE', label: 'Reggae' },
    { value: 'ROCK', label: 'Rock' },
    { value: 'SPOKEN_WORD', label: 'Spoken Word' },
    { value: 'SOUNDTRACK', label: 'Soundtrack' },
    { value: 'VOCAL', label: 'Vocal' },
    { value: 'WORLD', label: 'World' }]

    const yearOptions = [{ value: '2024', label: '2024' }, { value: '2023', label: '2023' }, { value: '2022', label: '2022' },     { value: '2021', label: '2021' }, { value: '2020', label: '2020' }, { value: '2019', label: '2019' }, { value: '2018', label: '2018' },     { value: '2017', label: '2017' },     { value: '2016', label: '2016' },     { value: '2015', label: '2015' },     { value: '2014', label: '2014' },     { value: '2013', label: '2013' },     { value: '2012', label: '2012' },     { value: '2011', label: '2011' },     { value: '2010', label: '2010' },     { value: '2009', label: '2009' },     { value: '2008', label: '2008' },     { value: '2007', label: '2007' },     { value: '2006', label: '2006' },     { value: '2005', label: '2005' },     { value: '2004', label: '2004' },     { value: '2003', label: '2003' },     { value: '2002', label: '2002' },     { value: '2001', label: '2001' },     { value: '2000', label: '2000' },     { value: '1999', label: '1999' },     { value: '1998', label: '1998' },     { value: '1997', label: '1997' },     { value: '1996', label: '1996' },     { value: '1995', label: '1995' },     { value: '1994', label: '1994' },     { value: '1993', label: '1993' },     { value: '1992', label: '1992' },     { value: '1991', label: '1991' },     { value: '1990', label: '1990' },    { value: '1989', label: '1989' },     { value: '1988', label: '1988' },     { value: '1987', label: '1987' },     { value: '1986', label: '1986' },     { value: '1985', label: '1985' },     { value: '1984', label: '1984' },     { value: '1983', label: '1983' },     { value: '1982', label: '1982' },     { value: '1981', label: '1981' },    { value: '1980', label: '1980' },     { value: '1979', label: '1979' },     { value: '1978', label: '1978' },     { value: '1977', label: '1977' },     { value: '1976', label: '1976' },     { value: '1975', label: '1975' },     { value: '1974', label: '1974' },     { value: '1973', label: '1973' },     { value: '1972', label: '1972' },     { value: '1971', label: '1971' },     { value: '1970', label: '1970' },     { value: '1969', label: '1969' },     { value: '1968', label: '1968' },     { value: '1967', label: '1967' },     { value: '1966', label: '1966' },     { value: '1965', label: '1965' },     { value: '1964', label: '1964' },     { value: '1963', label: '1963' },     { value: '1962', label: '1962' },     { value: '1961', label: '1961' },     { value: '1960', label: '1960' }, 
    { value: '1959', label: '1959' },     { value: '1958', label: '1958' },     { value: '1957', label: '1957' },     { value: '1956', label: '1956' },     { value: '1955', label: '1955' },     { value: '1954', label: '1954' },     { value: '1953', label: '1953' },     { value: '1952', label: '1952' },     { value: '1951', label: '1951' },     { value: '1950', label: '1950' },     { value: '1949', label: '1949' },     { value: '1948', label: '1948' },     { value: '1947', label: '1947' },     { value: '1946', label: '1946' },     { value: '1945', label: '1945' }]
                                  
    function topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    const changeAlbumExplicitHandler = value => {
        setExplicitAlbumContent(value) 
    }

    const changeRecordingYearHandler = value => {
      setRecordingYear(value) 
    }

  const changeCCopyrightYearHandler = value => {
    setCCopyrightYear(value) 
    }

    const changePCopyrightYearHandler = value => {
      setPCopyrightYear(value) 
    }


    const changeDistributeHandler = value => {
        setDistribute(value)
        setDistibuteError(false)
        }

    const changeFormatHandler = value => {
            setFormat(value)
            setFormatError(false)
          }

    const changeGenreHandler = value => {
            setGenre(value)
            setGenreError(false)
            }

    const changeSubgenreGenreHandler = value => {
                setSubGenre(value)
              }
      
    const changeAlternateGenreHandler = value => {
                setAlternateGenre(value)
              }
      
    const changeAlternateSubGenreHandler = value => {
                setAlternateSubGenre(value)
              }
    
    const changeAlbumLanguageHandler = value => {
                setAlbumLanguage(value)
              }

    const submitConsumerReleaseDate = (value) =>{
        const date = new Date(value.concat("T00:00"))
        setConsumerDateObj(date)
        // setConsumerReleaseDate(getMonthNo(date.getMonth()).concat("/").concat(getDateNo(date.getDate()).concat("/").concat(date.getFullYear()))) 
        setConsumerReleaseDate("".concat(date.getFullYear()).concat("-").concat(getMonthNo(date.getMonth()).concat("-").concat(getDateNo(date.getDate())))) 
        // setConsumerReleaseDate(date.getFullYear().concat("-").concat(getMonthNo(date.getMonth())).concat("-").concat(getDateNo(date.getDate())))
    }

    const submitPreorderDate = (value) =>{
        const date = new Date(value.concat("T00:00"))
        setPreorderDateObj(date)
    
        // setPreorderDate(getMonthNo(date.getMonth()).concat("/").concat(getDateNo(date.getDate()).concat("/").concat(date.getFullYear())))
        setPreorderDate("".concat(date.getFullYear()).concat("-").concat(getMonthNo(date.getMonth()).concat("-").concat(getDateNo(date.getDate())))) 
        // setPreorderDate(date.getFullYear().concat("-").concat(getMonthNo(date.getMonth())).concat("-").concat(getDateNo(date.getDate())))
    }

    const submitOriginalReleaseDate = (value) =>{
        const date = new Date(value.concat("T00:00"))
        setOriginalDateObj(date)
       
        // setOriginalReleaseDate(getMonthNo(date.getMonth()).concat("/").concat(getDateNo(date.getDate()).concat("/").concat(date.getFullYear())))
        setOriginalReleaseDate("".concat(date.getFullYear()).concat("-").concat(getMonthNo(date.getMonth()).concat("-").concat(getDateNo(date.getDate())))) 
        // setOriginalReleaseDate(date.getFullYear().concat("-").concat(getMonthNo(date.getMonth())).concat("-").concat(getDateNo(date.getDate())))
    }

    const handleImageDrag = (e) =>{
        e.preventDefault();
        e.stopPropagation();
  
        if (e.type === "dragenter" || e.type === "dragover") {
            setImageDragActive(true);
          } else if (e.type === "dragleave") {
            setImageDragActive(false);
          }
    }

    const resizeImage = (file, callback) => {
      const img = new Image();
      img.src = URL.createObjectURL(file);
    
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
    
        // Set canvas size to 4000x4000 pixels
        canvas.width = 4000;
        canvas.height = 4000;
    
        // Draw the image onto the canvas with 4000x4000 dimensions
        ctx.drawImage(img, 0, 0, 4000, 4000);
    
        // Convert the canvas to a Blob or Data URL and pass it to the callback
        canvas.toBlob((blob) => {
          const resizedFile = new File([blob], file.name, { type: file.type });
          callback(resizedFile);
        }, file.type);
      };
    };

    const handleImageChange = (e) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
          const filelist = []
          const img = new Image(); 
          img.src = URL.createObjectURL(e.target.files[0])
          img.onload = () => {
            console.log(img.height);
            console.log(img.width);
            if(img.height!==img.width){
            // CHANGE THIS IF REQUIRED
            // setAlbumImageError(true)
              resizeImage(e.target.files[0], (resizedFile) => {
                setAlbumImage([resizedFile]);
                setAlbumImageError(false);
              });
            }else if(img.height<3000 || img.height>6000 || img.width<3000 || img.width>6000){
               // CHANGE THIS IF REQUIRED
              // setAlbumImageError(true)
              resizeImage(e.target.files[0], (resizedFile) => {
                setAlbumImage([resizedFile]);
                setAlbumImageError(false);
              });
            }else{
              setAlbumImageError(false)
              // filelist.push(e.target.files[0])
              setAlbumImage([e.target.files[0]])
            }
          }
          // for(var i=0;i<e.target.files.length;i++){
          //   const img = new Image(); 
          //   img.src = URL.createObjectURL(e.target.files[0])
          //   img.onload = () => {
          //     console.log(img.height);
          //     console.log(img.width);
          //     if(img.height!==img.width){
          //       setAlbumImageError(true)
          //     }else if(img.height<3000 || img.height>6000 || img.width<3000 || img.width>6000){
          //       setAlbumImageError(true)
          //     }else{
          //       setAlbumImageError(false)
          //       // filelist.push(e.target.files[0])
          //       setAlbumImage(e.target.files[0])
          //     }
          //   }
            
          // }
  
         
        }
    };

    const checkDates =() =>{
      if(originalDateObj!==undefined && consumerDateObj!==undefined)
        if(originalDateObj<consumerDateObj){
          setDateError(true)
        }else{
          setDateError(false)
        }
    }

    useEffect(()=>{
      checkDates()
    },[originalDateObj,consumerDateObj])
  
  
      const onButtonClick = () => {
          inputRef.current.click();
      };

      const handleImageDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setImageDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          var filelist=[]
  
          const img = new Image(); 
          img.src = URL.createObjectURL(e.dataTransfer.files[0])
    
          img.onload = () => {
            console.log(img.height);
            console.log(img.width);
            if(img.height!==img.width){
              // CHANGE THIS IF REQUIRED
              // setAlbumImageError(true)
              urlToFile(img.src).then((file)=>{
                resizeImage(file, (resizedFile) => {
                  setAlbumImage([resizedFile]);
                  setAlbumImageError(false);
                });
              })
              // resizeImage(e.dataTransfer.files[0], (resizedFile) => {
              //   setAlbumImage([resizedFile]);
              //   setAlbumImageError(false);
              // });
            }else if(img.height<3000 || img.height>6000 || img.width<3000 || img.width>6000){
               // CHANGE THIS IF REQUIRED
              // setAlbumImageError(true)
              urlToFile(img.src).then((file)=>{
                resizeImage(file, (resizedFile) => {
                  setAlbumImage([resizedFile]);
                  setAlbumImageError(false);
                });
              })
              // resizeImage(e.dataTransfer.files[0], (resizedFile) => {
              //   setAlbumImage([resizedFile]);
              //   setAlbumImageError(false);
              // });
            }else{
              setAlbumImageError(false)
              // filelist.push(e.dataTransfer.files[0])
              setAlbumImage([e.dataTransfer.files[0]])
            }
          }
  
          // for(var i=0;i<e.dataTransfer.files.length;i++){
          //   const img = new Image(); 
          //   img.src = URL.createObjectURL(e.dataTransfer.files[0])
      
          //   img.onload = () => {
          //     console.log(img.height);
          //     console.log(img.width);
          //     if(img.height!==img.width){
          //       setAlbumImageError(true)
          //     }else if(img.height<3000 || img.height>6000 || img.width<3000 || img.width>6000){
          //       setAlbumImageError(true)
          //     }else{
          //       setAlbumImageError(false)
          //       // filelist.push(e.dataTransfer.files[0])
          //       setAlbumImage(e.dataTransfer.files[0])
          //     }
          //   }
   
          }
          
    };

    
    const urlToFile = async (imageUrl, filename = "image.jpeg") => {
        const response = await fetch(imageUrl);
        const blob = await response.blob();
        return new File([blob], filename, { type: blob.type });
    };

    const colourStyles = {
        control: styles => ({ ...styles,  borderColor: '#636468',
        backgroundColor:'rgba(0,0,0,16%)',
        width: '26em',
        height: '3em',
        borderRadius:'4px',
        color:'rgba(255, 255, 255, 1)',
        marginTop:'0.5em',
        "&:hover": {
          backgroundColor: "rgba(254,254,254,20%)"
        }
      }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
          return {
            ...styles,
            backgroundColor:'#18191F' ,
            color:'rgba(255, 255, 255, 1)',
            cursor: isDisabled ? 'not-allowed' : 'default',
            marginTop:'-0.3em',
            marginBottom:'-0.3em',
            "&:hover": {
              backgroundColor: 'rgba(0,0,0,100%)'
            }
          };
        },
        input: (styles) => ( {...styles , 
                                FontFamily:'ClashGrotesk-Variable,sans-serif',
                                FontSize:'1rem',
                                FontWeight: 'medium',
                                LineHeight: '150%',
                                LetterSpacing: '0%',
                                color:'rgba(255, 255, 255, 1)'}),
        singleValue : (styles) => ({ ...styles, 
                                        color:'rgba(255, 255, 255, 1)',
                                        FontFamily:'ClashGrotesk-Variable,sans-serif',
                                        FontSize:'1rem',
                                        FontWeight: 'medium',
                                        LineHeight: '150%',
                                        LetterSpacing: '0%'}),
        hover : styles =>({
                                          backgroundColor:'rgba(255,255,255,16%)',
          })
      };


      const getLanguageOptions = () =>{
        axios({
          method:'get',
          url:"https://n3rve.fly.dev/metadata/audio_locales",
          headers:{
              Authorization: "Bearer ".concat(cookies.get("token"))
          }
      }).then((response)=>{
        if(response.status===200){
          console.log(response.data)
          var langs= []
          response.data.map((option)=>{
            langs.push({ value: option.id, label: option.name })
          })
          setLangOptions(langs)
        }
      }).catch(function (e){
        console.log(e.response)
      })    
      }

    const errorCheck = () =>{
        console.log("In Submit")
        console.log(genre.length)
        console.log(distributeAs.length)
        console.log(format.length)
        var titleerror
        var genreerror
        var distributeerror
        var formaterror
  
         if(releaseTitle.length===0){
          setReleaseTitleError(true)
          titleerror = true
         }else{
          setReleaseTitleError(false)
          titleerror = false
         }
  
  
         if(genre.length!==undefined){
          setGenreError(true)
          genreerror = true
         }else{
          setGenreError(false)
          genreerror = false
         }
  
         if(distributeAs.length!==undefined){
          setDistibuteError(true)
          distributeerror= true
         }else{
          setDistibuteError(false)
          distributeerror= false
         }
  
         if(format.length!==undefined){
          setFormatError(true)
          formaterror=true
         }else{
          setFormatError(false)
          formaterror=false
         }
         return [titleerror,genreerror,distributeerror,formaterror]
    }
    
    useEffect(()=>{
      if(decodeToken(cookies.get('token')).info!==undefined){
        if(decodeToken(cookies.get('token')).info.artistName!==undefined){
          setArtistname(decodeToken(cookies.get('token')).info.artistName)
        }
      }
      if(genre.length!==0){
        setDisplayGenre(genre.label)
      }
      if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
        setPagePath("/Dashboard/releasemusic/albumdetails")
     }
  
     if(decodeToken(cookies.get('token')).info.role==="label"){
        setPagePath("/dashboard/label/releasemusic/albumdetails")
     }
      getLanguageOptions()
    },[])

    useEffect(()=>{

    },[originalReleaseDate,consumerReleaseDate,preorderDate])


    function BasicSwitch({ switchChecked, setSwitchChecked, ...props }) {
      const { getInputProps, disabled, focusVisible } = useSwitch(props);
     
       
      // useEffect(()=>{
      // //  switchChecked=check
      //  switchstatus=checked
      //   console.log(switchstatus)
      // },[checked])

    
      const stateClasses = {
        'Switch-checked':switchChecked,
        'Switch-disabled': disabled,
        'Switch-focusVisible': focusVisible,
      };

      const handleChange = (event) => {
        setSwitchChecked(event.target.checked);
      };
    
      return (
        <BasicSwitchRoot className={clsx(stateClasses)}>
          <BasicSwitchThumb className={clsx(stateClasses)} />
          <BasicSwitchInput {...getInputProps()} aria-label="Demo switch"  checked={switchChecked} onChange={handleChange}/>
        </BasicSwitchRoot>
      );
    }
  
    const BasicSwitchRoot = styled('span')(
      ({ theme }) => `
      box-sizing: border-box;
      font-size: 0;
      position: relative;
      display: inline-block;
      width: 38px;
      height: 24px;
      margin: 10px;
      cursor: pointer;
      background: ${theme.palette.mode === 'dark' ? '#1C2025' : '#F3F6F9'};
      
      border-radius: 24px;
      box-shadow: inset 0px 1px 1px ${
        theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.05)'
      };
    
      &:hover {
        background: ${theme.palette.mode === 'dark' ? '#303740' : '#E5EAF2'};
      }
        
      &.Switch-focusVisible {
        box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? '#C7A5FF' : '#C7A5FF'};
      }
    
      &.Switch-disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    
      &.Switch-checked {
       
        background: ${'#C7A5FF'};
        box-shadow: inset 0px 1px 1px ${
          theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.2)' : 'rgba(0, 0, 0, 0.05)'
        };
        &.Switch-focusVisible {
          box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? '#C7A5FF' : '#C7A5FF'};
        }
      }
      
      `,
    );
    
    const BasicSwitchInput = styled('input')`
      box-sizing: border-box;
      cursor: inherit;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      z-index: 1;
      margin: 0;
    `;
    
    const BasicSwitchThumb = styled('span')(
      ({ theme }) => `
      box-sizing: border-box;
      display: block;
      width: 16px;
      height: 16px;
      top: 3px;
      left: 2px;
      border-radius: 16px;
      background-color: #fff;
      
      position: relative;
      transition-property: all;
      transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
      transition-duration: 120ms;
      box-shadow: 0px 1px 2px
        ${theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.25)' : 'rgba(0, 0, 0, 0.1)'};
    
      &.Switch-checked {
        left: 17px;
        background-color: #fff;
       
      }
    `,
    );

    return (
        <div style={{display:'flex',flexDirection:'column',alignItems:"center"}} ref={ref}>
        <div className="AddMusicHeader">{t('Addreleasedetails')}</div>
  
       <div className="AddMusicDesc">{t('Completefieldsandcontinue')}</div>

       <div className="ReleaseDetailsModule">
             <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'40%'}}>
               <div className="AlbumDetailsSectionHeader" style={{marginLeft:'4.5em'}}>
                 GENERAL INFORMATION
               </div>

               {
                 albumImage.length===0 &&
                 <form id="form-file-upload5" style={{cursor:'pointer',marginLeft:'4.7em',marginTop:'1em'}} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
                 <input ref={inputRef} type="file"  id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                   <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : "" }>
                       <div className="AlbumPicUpload" style={{backgroundImage:`url(${UploadCoverArt})`}}>
                         <span className="CoverartText"> 
                         <Trans i18nKey="Dragordrop" components={{1:<br/>}} >
                         Drag and Drop your files here <br/> or 
                         </Trans>
                             <button className="upload-button" onClick={onButtonClick} style={{color:'#C7A5FF',textDecoration:'underline'}}>
                             {t('Browseyourfiles')} 
                                   </button> 
                         </span>
                       </div>
                   </label>
               { ImageDragActive && <div id="drag-file-element" onDragEnter={handleImageDrag} onDragLeave={handleImageDrag} onDragOver={handleImageDrag} onDrop={handleImageDrop}></div> }
               </form>
               }

               {
                           albumImage.length!==0 &&
                           <form id="form-file-upload5" style={{cursor:'pointer',display:'flex',flexDirection:'column',marginLeft:'4.7em',marginTop:'4em'}} onDragEnter={handleImageDrag} onSubmit={(e) => e.preventDefault()}>
                           <input ref={inputRef} type="file"  style={{backgroundColor:'pink'}} id="input-file-upload" multiple={false} onChange={handleImageChange} accept="image/png, image/jpeg" />
                             <label id="label-file-upload" htmlFor="input-file-upload" className={ImageDragActive ? "drag-active" : "" }>
                                 <img src={URL.createObjectURL(albumImage[0])} style={{width:'13.18em',height:'13.18em',marginTop:'2.5em',borderRadius:'8px'}}/>
                                 <div className="ReplaceImgTxt" style={{marginTop:'1em'}}>Replace image</div>
                             </label>
                           
                         { ImageDragActive && <div id="drag-file-element" onDragEnter={handleImageDrag} onDragLeave={handleImageDrag} onDragOver={handleImageDrag} onDrop={handleImageDrop}></div> }
                         </form>

               }
                {
                 albumImageError &&
                 <div className="AddMusicDesc" style={{color:'#FF8686',marginTop:'1.5em',marginLeft:'-5.5em'}}>Incorrect Image Format</div>
               }

             </div>

             <div style={{display:'flex',flexDirection:'column'}}>
                 <span className="InputHeader">
                 {t('Releasetitle')} <span style={{color:'#E91353'}}>*</span>
                 </span>


              
                 <input
                 value={releaseTitle}
                 onChange={e =>{setReleaseTitle(e.target.value);}} 
                 className='InputField'
                 type='text'
                 placeholder= {t('Enterreleasetitle')}
                 // style={{marginLeft:'4.8em'}}
                 />

               <span className="InputHeader">
                 {t('Artistname')} 
               </span>
              

               <input
                               value={artistName}
                               disabled
                               className='FilledInputField'
                               type='text'
                               // style={{marginLeft:'4.8em'}}
                               />

               <span className="InputHeader">
               {t('Distributeas')}  <span style={{color:'#E91353',marginTop:'0em'}}>*</span>
               </span>

              
               <Select options={distributeOptions} value={distributeAs} onChange={changeDistributeHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Choose one"
               styles={
                 colourStyles
               }
               />
             

             </div>
       </div>

       <div className={formatcontainerclass}>
             <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'40%'}}>
               <div className="AlbumDetailsSectionHeader" style={{marginLeft:'4.5em'}}>
                 FORMAT DETAILS
               </div>


             </div>

             <div style={{display:'flex',flexDirection:'column'}}>
                 <span className="InputHeader">
                 {t('Format')} <span style={{color:'#E91353'}}>*</span>
                 </span>

                 {
               cookies.get('lang') === 'jp' &&
               <Select options={jpformatOptions} value={format} onChange={changeFormatHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Choose one"
               styles={
                 colourStyles
               }
               />
             }

             {
               cookies.get('lang') === 'en' &&
               <Select options={formatOptions} value={format} onChange={changeFormatHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Choose one"
               styles={
                 colourStyles
               }
               />
             }

             {
               formatcontainerclass==="FormatDetailsModuleOpen" &&
               <div style={{display:'flex',flexDirection:'column'}}>
                 <div style={{display:'flex',flexDirection:'row',marginTop:'2.5em'}}>
                     <div style={{display:'flex',flexDirection:'column'}}>
                       <span className="InputHeader">
                       Total volumes
                       </span>

                       <input
                               value={totalVolumes}
                               onChange={e =>{setTotalVolumes(e.target.value);}} 
                               className='InputField'
                               type='number'
                               placeholder= {1}
                               style={{width:'12.5em'}}
                               />

                     </div>

                     <div style={{display:'flex',flexDirection:'column',alignItems:'center',marginLeft:'2.5em'}}>
                       <span className="InputHeader">
                       Compilation
                       </span>
                       <BasicSwitch switchChecked={switchChecked} setSwitchChecked={setSwitchChecked}/>
                    
                     </div>

                     

                 </div>

                 <span className="InputHeader">
                     Explicit content
                 </span>

                 <Select options={ExplicitContentOptions} value={explicitAlbumContent} onChange={changeAlbumExplicitHandler} 
                 components={{
                   IndicatorSeparator: () => null
                 }}
                 placeholder="Choose one"
                 styles={
                   colourStyles
                 }
                 />

               </div>
             } 

           
             {
               (formatcontainerclass==="FormatDetailsModuleClosed" || formatcontainerclass==="FormatDetailsModule") &&
               <div className="AdvanceFieldsBtn" onClick={()=>setFormatContainerClass("FormatDetailsModuleOpen")}>
               Advanced fields
             </div>
             }

           {
               formatcontainerclass==="FormatDetailsModuleOpen" &&
               <div className="AdvanceFieldsBtn" onClick={()=>setFormatContainerClass("FormatDetailsModuleClosed")}>
               Hide advanced fields
             </div>
             }
            
            

             </div>
       </div>

       
       <div className={defaultdatecontainerclass}>
             <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'40%'}}>
               <div className="AlbumDetailsSectionHeader" style={{marginLeft:'4.5em'}}>
                 DEFAULT DATES
               </div>


             </div>

             <div style={{display:'flex',flexDirection:'column'}}>


                   <span className="InputHeader">
                  Consumer release date <span style={{color:'#E91353'}}>*</span>
                   </span>
                   
                 
            

                 <div className='ReleaseDateBox' style={{width:'24.5em',marginTop:'0.6em',minHeight:'3em',cursor:'pointer'}} 
                 onClick={() => consumerdateInputRef.current && consumerdateInputRef.current.showPicker()}>
                   {
                     consumerReleaseDate.length===0 && 
                     <div>
                       Select a release date 
                     </div>
                   }
                    {
                     consumerReleaseDate.length!==0 && 
                     <div>
                      {consumerReleaseDate}
                     </div>
                   }
                   {/** PENDING CHANGE MAYBE */}
                 <input
                               ref={consumerdateInputRef}
                               value={consumerReleaseDate}
                               onChange={e =>submitConsumerReleaseDate(e.target.value)} 
                               onSubmit={e =>submitConsumerReleaseDate(e.target.value)}
                               className='ReleaseDateInputBox'
                               type='date'
                              
                               />


                    {/* <input
                               value={consumerReleaseDate}
                               onChange={e =>setConsumerReleaseDate(e.target.value)} 
                               onSubmit={e =>setConsumerReleaseDate(e.target.value)}
                               className='ReleaseDateInputBox'
                               type='date'
                              
                               /> */}
                             
                </div>
                 
                {
               defaultdatecontainerclass==="DefaultDateDetailsModuleOpen" &&
               <div style={{display:'flex',flexDirection:'column',marginTop:'1.5em'}}>
                <span className="InputHeader">
                Consumer release time
                 </span>

               
              <div style={{position:'relative'}}>
                 <input
                 value={consumerReleaseTime}
                 onChange={e =>{setConsumerReleaseTime(e.target.value);}} 
                 className='InputField'
                 type='time' 
                 placeholder= "Enter Release Time"
                 style={{width:'96%',zIndex:'2'}}
                 // style={{marginLeft:'4.8em'}}
                
                 />
                  {/* <img src={ArrowDown} style={{position:'absolute',right:'0.5em',top:'1.7em',zIndex:'1'}}/> */}
                  </div>
                 


           <span className="InputHeader">
                Preorder date
                 </span>

                 <div className='ReleaseDateBox' style={{width:'24.5em',marginTop:'0.6em',minHeight:'3em',cursor:'pointer'}}
                 onClick={() => preorderdateInputRef.current && preorderdateInputRef.current.showPicker()}>
                   {
                     preorderDate.length===0 && 
                     <div>
                      Select a preorder date
                     </div>
                   }
                    {
                     preorderDate.length!==0 && 
                     <div>
                      {preorderDate}
                     </div>
                   }
                 {/** PENDING CHANGE MAYBE */}
                 <input
                              ref={preorderdateInputRef}
                               value={preorderDate}
                               onChange={e =>submitPreorderDate(e.target.value)} 
                               onSubmit={e =>submitPreorderDate(e.target.value)}
                               className='ReleaseDateInputBox'
                               type='date'
                              
                               />
                {/* <input
                               value={preorderDate}
                               onChange={e =>setPreorderDate(e.target.value)} 
                               onSubmit={e =>setPreorderDate(e.target.value)}
                               className='ReleaseDateInputBox'
                               type='date'
                              
                               /> */}
                             
                </div>
               </div>
           }

                


               

            
             {
               (defaultdatecontainerclass==="DefaultDateDetailsModuleClosed" || defaultdatecontainerclass==="DefaultDateDetailsModule") &&
               <div className="AdvanceFieldsBtn" onClick={()=>setDefaultDateContainerClass("DefaultDateDetailsModuleOpen")}>
               Advanced fields
             </div>
             }

           {
               defaultdatecontainerclass==="DefaultDateDetailsModuleOpen" &&
               <div className="AdvanceFieldsBtn" onClick={()=>setDefaultDateContainerClass("DefaultDateDetailsModuleClosed")}>
               Hide advanced fields
             </div>
             }
            
            

             </div>
       </div>

        <div className={releasedatecontainerclass}>
             <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'40%'}}>
               <div className="AlbumDetailsSectionHeader" style={{marginLeft:'4.5em'}}>
                 ORIGINAL RELEASE
               </div>


             </div>

             <div style={{display:'flex',flexDirection:'column'}}>

                 <div style={{display:'flex',flexDirection:'row',position:'relative'}}>
                   <span className="InputHeader">
                   Original release date <span style={{color:'#E91353'}}>*</span>
                   </span>
                   <img src={DisclaimerPopup} style={{width:'1em',height:'1em',marginTop:'-0em',marginLeft:'0.2em',padding:'0.4em'}} className="DisclaimerHover" onMouseOver={()=>setDisclaimer(true)} onMouseLeave={()=>setDisclaimer(false)}/>

                   {  
                               disclaimer &&
                                 <div style={{position:'absolute',display:'flex',flexDirection:'column',marginTop:'-10.1em',marginLeft:'3.8em'}} onMouseOver={()=>setDisclaimer(true)} onMouseLeave={()=>setDisclaimer(false)}>
                                   <div className='DisclaimerContainer' style={{width:'15.43em'}}>
                                   Original release date is when the music was first made available to the public, marking its initial distribution or publication.
                                   </div>
                                   <img src={ArrowDown} style={{width:'1.5em',height:'1em',position:'absolute',left:'5.8em',top:'9.2em'}}/>
                                 </div>
                               }
                 
                 </div>

                 <div className='ReleaseDateBox' style={{width:'24.5em',marginTop:'0.6em',minHeight:'3em',cursor:'pointer'}}
                  onClick={() => originaldateInputRef.current && originaldateInputRef.current.showPicker()}>
                   {
                     originalReleaseDate.length===0 && 
                     <div>
                       {t('Selectadate')}
                     </div>
                   }
                    {
                     originalReleaseDate.length!==0 && 
                     <div>
                      {originalReleaseDate}
                     </div>
                   }
                     {/** PENDING CHANGE MAYBE */}
                        <input
                               ref={originaldateInputRef}
                               value={originalReleaseDate}
                               onChange={e =>submitOriginalReleaseDate(e.target.value)} 
                               onSubmit={e =>submitOriginalReleaseDate(e.target.value)}
                               className='ReleaseDateInputBox'
                               type='date'
                              
                               />
                        {/* <input
                               value={originalReleaseDate}
                               onChange={e =>setOriginalReleaseDate(e.target.value)} 
                               onSubmit={e =>setOriginalReleaseDate(e.target.value)}
                               className='ReleaseDateInputBox'
                               type='date'
                              
                               /> */}
                             
                </div>
                 
                 {
                  dateerror &&
                  <div className='ErrorTxt' style={{marginTop:'0.3em',marginBottom:'-0.5em'}}>Original Release Date must be after Consumer Release Date</div>
                 }
                {
               releasedatecontainerclass==="ReleaseDateDetailsModuleOpen" &&
               <div style={{display:'flex',flexDirection:'column',marginTop:'1.5em'}}>
                <span className="InputHeader">
                Recording year 
                 </span>

                 <Select options={yearOptions} value={recordingYear} onChange={changeRecordingYearHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Enter recording year"
               styles={
                 colourStyles
               }
               />
              
                 {/* <input
                 value={recordingYear}
                 onChange={e =>{setRecordingYear(e.target.value);}} 
                 className='InputField'
                 type='number' 
                 placeholder= "Enter recording year"
                 maxLength={4}
                 // style={{marginLeft:'4.8em'}}
                 /> */}

           <span className="InputHeader" style={{marginTop:'1.5em'}}>
                Recording location
                 </span>

             <input
                 value={recordingLocation}
                 onChange={e =>{setRecordingLocation(e.target.value);}} 
                 className='InputField'
                 type='text'
                 placeholder= "Enter recording location"
                 // style={{marginLeft:'4.8em'}}
                 />
               </div>
}

                


               

            
             {
               (releasedatecontainerclass==="ReleaseDateDetailsModuleClosed" || releasedatecontainerclass==="ReleaseDateDetailsModule") &&
               <div className="AdvanceFieldsBtn" onClick={()=>setReleaseDateContainerClass("ReleaseDateDetailsModuleOpen")}>
               Advanced fields
             </div>
             }

           {
               releasedatecontainerclass==="ReleaseDateDetailsModuleOpen" &&
               <div className="AdvanceFieldsBtn" onClick={()=>setReleaseDateContainerClass("ReleaseDateDetailsModuleClosed")}>
               Hide advanced fields
             </div>
             }
            
            

             </div>
       </div>

       
       <div className="ReleaseDetailsModule">
             <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'40%'}}>
               <div className="AlbumDetailsSectionHeader" style={{marginLeft:'4.5em'}}>
                 COPYRIGHTS
               </div>


             </div>

             <div style={{display:'flex',flexDirection:'column'}}>
                
                 <span className="InputHeader">
                 © Copyright year <span style={{color:'#E91353'}}>*</span>
                 </span>

                 <Select options={yearOptions} value={cCopyrightYear} onChange={changeCCopyrightYearHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Enter copyright year"
               styles={
                 colourStyles
               }
               />
              
              
                 {/* <input
                 value={cCopyrightYear}
                 onChange={e =>{setCCopyrightYear(e.target.value);}} 
                 className='InputField'
                 type="number"
                 placeholder= "Enter copyright year"
                 min="1893" 
                 max="2024"
                 onInput={e=>{ if (e.target.value.length > 4) {e.target.value = e.target.value.slice(0,4)} }}
                 // style={{marginLeft:'4.8em'}}
                 /> */}

                   <span className="InputHeader" style={{marginTop:'1.5em'}}>
                   © Copyright text <span style={{color:'#E91353'}}>*</span>
                 </span>


              
                 <input
                 value={cCopyrightText}
                 onChange={e =>{setCCopyrightTexy(e.target.value);}} 
                 className='InputField'
                 type='text'
                 placeholder= "Enter copyright text"
                 // style={{marginLeft:'4.8em'}}
                 />

                   <span className="InputHeader">
                   ℗ Copyright year <span style={{color:'#E91353'}}>*</span>
                 </span>

                 <Select options={yearOptions} value={pCopyrightYear} onChange={changePCopyrightYearHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Enter copyright year"
               styles={
                 colourStyles
               }
               />
              
                 {/* <input
                 value={pCopyrightYear}
                 onChange={e =>{setPCopyrightYear(e.target.value);}} 
                 className='InputField'
                 type='number'
                 placeholder= "Enter copyright year"
                 min="1893" 
                 max="2024"
                //  onInput={e=>{ if (e.target.value.length > 4) {e.target.value = e.target.value.slice(0,4)} }}
                 // style={{marginLeft:'4.8em'}}
                 /> */}

                   <span className="InputHeader" style={{marginTop:'1.5em'}}>
                   ℗ Copyright text <span style={{color:'#E91353'}}>*</span>
                 </span>


              
                 <input
                 value={pCopyrightText}
                 onChange={e =>{setPCopyrightTexy(e.target.value);}} 
                 className='InputField'
                 type='text'
                 placeholder= "Enter copyright text"
                 // style={{marginLeft:'4.8em'}}
                 />
             
            
            

             </div>
       </div>

       <div className={genrecontainerclass}>
             <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'40%'}}>
               <div className="AlbumDetailsSectionHeader" style={{marginLeft:'4.5em'}}>
                 GENRE
               </div>


             </div>

             <div style={{display:'flex',flexDirection:'column'}}>
                 <span className="InputHeader">
                 {t('Genre')} <span style={{color:'#E91353'}}>*</span>
                 </span>

                 <Select options={genreOptions} value={genre} onChange={changeGenreHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Choose genre"
               styles={
                 colourStyles
               }
               />

               {
                 genrecontainerclass==="GenreDetailsModuleOpen" &&
                 <div style={{display:'flex',flexDirection:'column'}}>
                    <span className="InputHeader" style={{marginTop:'1.5em'}}>
                 Subgenre
                 </span>

                 <Select options={genreOptions} value={subgenre} onChange={changeSubgenreGenreHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Choose subgenre"
               styles={
                 colourStyles
               }
               />

               <span className="InputHeader"  style={{marginTop:'1.5em'}}>
                 Alternate genre
                 </span>

                 <Select options={genreOptions} value={alternategenre} onChange={changeAlternateGenreHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Choose alternate genre"
               styles={
                 colourStyles
               }
               />

             <span className="InputHeader" style={{marginTop:'1.5em'}}> 
                 Alternate subgenre
                 </span>

                 <Select options={genreOptions} value={alternateSubgenre} onChange={changeAlternateSubGenreHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Choose alternate subgenre"
               styles={
                 colourStyles
               }
               />
                 </div>
               }
              

   
             {
               (genrecontainerclass==="GenreDetailsModuleClosed" || genrecontainerclass==="GenreDetailsModule") &&
               <div className="AdvanceFieldsBtn" onClick={()=>setGenreContainerClass("GenreDetailsModuleOpen")}>
               Advanced fields
             </div>
             }

           {
               genrecontainerclass==="GenreDetailsModuleOpen" &&
               <div className="AdvanceFieldsBtn" onClick={()=>setGenreContainerClass("GenreDetailsModuleClosed")}>
               Hide advanced fields
             </div>
             }
            
            

             </div>
       </div>

       <div className="ReleaseDetailsModule">
             <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start',width:'40%'}}>
               <div className="AlbumDetailsSectionHeader" style={{marginLeft:'4.5em'}}>
                 METADATA LANGUAGE
               </div>


             </div>

             <div style={{display:'flex',flexDirection:'column'}}>
                
                 <span className="InputHeader">
                 Default language
                 </span>


                 <Select options={LangOption} value={albumLanguage} onChange={changeAlbumLanguageHandler} 
               components={{
                 IndicatorSeparator: () => null
               }}
               placeholder="Choose Language"
               styles={
                 colourStyles
               }
               />
                


              
             
            
            

             </div>
       </div>


       <div style={{display:'flex',flexDirection:'row',marginTop:'3.5em',paddingBottom:'4em'}}>
         <div className="BackBtn2" onClick={()=>{
           if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
            navigate("/Dashboard/releasemusic/uploadphoto")
          }

          if(decodeToken(cookies.get('token')).info.role==="label"){
            navigate("/dashboard/label/releasemusic/uploadphoto")
          }}}>
         {t('Back')} 
         </div>

         

         {
           (releaseTitle.length===0  || distributeAs.length!==undefined || format.length!==undefined || consumerReleaseDate.length===0 || originalReleaseDate.length===0 || pCopyrightYear.length===0 || pCopyrightText.length===0  || cCopyrightYear.length===0 || cCopyrightText.length===0 || genre.length!==undefined || dateerror)  &&
           <div className="NextBtn2" style={{backgroundColor:'#821D41',color:'#8D9297',cursor:'auto'}}>
           {t('Next')}  
           </div>
         }
{/* && consumerReleaseDate.length!==0 && originalReleaseDate.length!==0 && pCopyrightYear.length!==0 && pCopyrightText.length!==0  && cCopyrightYear.length!==0 && cCopyrightText.length!==0  */}
         {
           (releaseTitle.length!==0  && distributeAs.length!==0 && format.length!==0 && consumerReleaseDate.length!==0 && originalReleaseDate.length!==0 && pCopyrightYear.length!==0 && pCopyrightText.length!==0  && cCopyrightYear.length!==0 && cCopyrightText.length!==0  && genre.length!==0 && !dateerror) &&
           <div className="NextBtn2" onClick={()=>{const values=errorCheck();
             // handleformsubmit(values[0],values[1],values[2],values[3]);
              /** PENDING */
            //  setCheckAssetArr(Math.random())
            setSwitchChecked(switchstatus)
            if(decodeToken(cookies.get('token')).info.role==="artist" || decodeToken(cookies.get('token')).info.role==="producer"){
              navigate("/Dashboard/releasemusic/trackdetails")
            }
  
            if(decodeToken(cookies.get('token')).info.role==="label"){
              navigate("/dashboard/label/releasemusic/trackdetails")
            }
          
            }}>
          {t('Next')}  
          <div className="PostLoginBtnOverlay"/>
           </div>
         }
       </div>
   </div>
        
    );
}

export default AlbumDetails;

